import { useContext } from "react";
import { StorageContext } from "./storage-context";

/**
 * Hook to access storage context (userId and conversationId).
 * Must be used within a StorageProvider.
 *
 * @throws Error if used outside of StorageProvider
 */
export function useStorageContext() {
  const context = useContext(StorageContext);
  if (context === undefined) {
    throw new Error("useStorageContext must be used within a StorageProvider");
  }
  return context;
}
